import React from "react";
import type { TextButtonProps } from "../TextButtonLegacy";

type TextButtonInnerProps = Pick<
  TextButtonProps,
  "withIcon" | "icon" | "labelIcon" | "farUnderline"
> & {
  children: string | React.ReactNode;
  iconPosition?: "left" | "right";
};

const TextButtonInner = ({
  children,
  withIcon,
  icon,
  labelIcon = "Go to page",
  farUnderline = true,
  iconPosition = "right",
}: TextButtonInnerProps) => {
  const defaultLeftArrowSvgPath = "M13 4L7 10L13 16";
  const defaultRightArrowSvgPath = "M7 4L13 10L7 16";

  const defaultIcon = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={`${iconPosition === "left" ? defaultLeftArrowSvgPath : defaultRightArrowSvgPath}`}
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );

  const iconElement = (
    <span
      className={`inline-flex h-[20px] w-[20px] items-center justify-center ${
        iconPosition === "left" ? "mr-1" : "ml-1"
      }`}
      aria-label={labelIcon}
    >
      {icon || defaultIcon}
    </span>
  );

  return (
    <>
      {withIcon && iconPosition === "left" && iconElement}
      <span
        className={`inline underline ${
          farUnderline && "[text-underline-position:under]"
        }`}
      >
        {children}
      </span>
      {withIcon && iconPosition === "right" && iconElement}
    </>
  );
};

export default TextButtonInner;
